import React from 'react';

export const OnlineModule = (props) => {

    return(
        <div className="four-online">
            <div className="four-right-top">
                <img src={require('../../../assets/images/fiveModule/book/banner.png')} alt="选考在线" />
            </div>
            <div className="four-online-right-bottom">
                <section className='section-1'>
                    <div className='title fs-28'>《大数据精准助报80个高考志愿》</div>
                    <div className='description fs-16'>
                    《大数据精准助报80个高考志愿》是首本以专业为逻辑，同一（或相近）专业按高校录取位次号序的志愿填报书，汇集了近3年各高校各专业的录取大数据，包括：各高校各专业连续3年的投档最低分、位次号、选考科目、招生计划、学费等。除此之外，还包括80个高考志愿填报策略、招生录取政策解读、“三位一体”招生办法、艺体类志愿填报及如何选择大学与专业等等考生最关心的内容，并提供了详细的80个高考志愿填报案例分析。大数据书已连续多年出版，受到考生及家长的赞扬和业内人士的广泛关注。
                    </div>
                    <div className='items'>
                        <div className='item'>
                            <img src={require('../../../assets/images/fiveModule/book/logo_1.png')} alt="选考在线" />
                            <img src={require('../../../assets/images/fiveModule/book/logo_1_desc.png')} alt="选考在线" />
                        </div>
                        <div className='item'>
                            <img src={require('../../../assets/images/fiveModule/book/logo_2.png')} alt="选考在线" />
                            <img src={require('../../../assets/images/fiveModule/book/logo_2_desc.png')} alt="选考在线" />
                        </div>
                        <div className='item'>
                            <img src={require('../../../assets/images/fiveModule/book/logo_3.png')} alt="选考在线" />
                            <img src={require('../../../assets/images/fiveModule/book/logo_3_desc.png')} alt="选考在线" />
                        </div>
                    </div>
                    <div className='book'>
                        <img className='shadow' src={require('../../../assets/images/fiveModule/book/book1.png')} alt="选考在线" />
                        <div className='right'>
                            <div className='point'>内容亮点</div>
                            <div>①依照招生“专业（类）+大学”的录取位次号排序，与当年高考志愿填报相匹配。</div>
                            <div>②适合各段普通类考生以及艺术、体育类考生参考使用。</div>
                            <div>③以专业为逻辑，同一（或相近）专业按高校录取位次号排序，最大可能地提供了专业优选余地。</div>
                            <div>④大数据作支撑，位次排列清晰，一目了然，80个高考志愿一本书全搞定。</div>
                            <div>⑤选取了分数信息和位次号信息，有助于预估各校录取分数大致范围。</div>
                            <div>⑥专家详细解读浙江省高考招生录取政策。</div>
                        </div>
                    </div>
                    <div className='recomend'>
                        <img src={require('../../../assets/images/fiveModule/book/recommend.png')} alt="选考在线" />
                        <div className='right fs-16'>
                            <div>本书清晰呈现了各高校同一专业间的录取分数和位次号差异，大大方便了浙江考生精准把握专业平行志愿并精准填报80个高考志愿。</div>
                            <div className='text-align-right'>————中国人民大学浙江招生组组长 姚欢庆</div>
                            <div>高考志愿填报关乎考生未来发展，不可不慎！我认为，与同类志愿填报书相比，本书高过一筹。为此，我非常愿意向考生推荐。</div>
                            <div className='text-align-right'>————浙江大学高等教育研究所高考政策研究室主任 吕阳</div>
                            <div>高报咨询萦云雾，一招不慎几沉浮，掐指一算神相助，定海神针困惑纾，滋润高报需雨露，此书在手即地图。</div>
                            <div className='text-align-right'>————丽水中学资深志愿咨询师 郑彩亮</div>
                        </div>
                    </div>
                </section>
                <section className='section-2'>
                    <div className='title fs-28'>《高中生升学日历问答》</div>
                    <div className='main'>
                        <div className='description fs-16'>
                        《高中生升学日历问答》以独特的日历问答形式，系统地覆盖了学习方法、大学介绍、专业选择、学业规划、多元升学路径以及志愿填报等高中阶段学生亟需了解的关键信息。本书以升学时间轴为主线，每日一问答，确保学生在每个关键时间节点都能获得最及时、最实用的指导与建议。书中不仅详细解答了学生在升学过程中可能遇到的各种疑问，还通过拓展阅读材料，如小贴士、升学链接、升学案例等，帮助学生更全面地了解升学信息。
                        </div>
                        <img src={require('../../../assets/images/fiveModule/book/book2.png')} alt="选考在线" />
                    </div>
                </section>
                <section className='section-3'>
                    <div className='title fs-28'>“三位一体”&“高职提前”系列教材</div>
                    <div className='description fs-16'>
                    《名校“三位一体”与“强基计划”招生闯关秘籍》、《浙江省属院校“三位一体”招生闯关秘籍》、《“三位一体”招生面试指南》、《浙江省“高职提前招生”闯关秘籍》是“选考在线”专为高中生精心编写的多元升学报考指南，旨在帮助考生深入了解并有效应对浙江新高考独有的“三位一体”综合评价招生（含浙江省属院校和高水平大学“三位一体”）、国内顶尖高校招生的“强基计划”及高职提前招生。该系列教材通过详尽的政策解读、招考流程分析、应试策略及历年真题解析，为考生提供了一条通往理想高校的清晰路径。
                    </div>
                    <img src={require('../../../assets/images/fiveModule/book/book3.png')} alt="选考在线" />
                </section>
            </div>
        </div>
    )
}

export default OnlineModule;